












































































































































import Vue from 'vue';

import Icons from '@/icons';

import Goal from '@/components/Goal.vue';

const rubricExample = [
  [
    'Creativity',
    // mdi-arrow-decision-outline
    Icons.lookup('MaterialDesignIconFont', 0xf9bd),
    '#FB8C00',
    'Learning'
  ],
  [
    'Communication',
    // mdi-phone-in-talk
    Icons.lookup('MaterialDesignIconFont', 0xf3f6),
    '#81C794',
    'Trying'
  ],
  [
    'Abstract Thinking',
    // mdi-thought-bubble
    Icons.lookup('MaterialDesignIconFont', 0xf7f5),
    '#4DB6AC',
    'Mastering'
  ]
];

const singleExample = [
  ['Empathize', Icons.lookup('MaterialDesignIconFont', 0xf898), '#E1C397'], // mdi-account-heart
  ['Design', Icons.lookup('MaterialDesignIconFont', 0xf937), '#E7E87F'], // mdi-angle-obtuse
  ['Ideate', Icons.lookup('MaterialDesignIconFont', 0xf9d0), '#A7CAE8'], // mdi-brain
  ['Prototype', Icons.lookup('MaterialDesignIconFont', 0xf034), '#C9ECA8'], // mdi-android-studio
  ['Test', Icons.lookup('MaterialDesignIconFont', 0xfc2d), '#B79EE6'] // mdi-check-box-multiple-outline
];

export default Vue.extend({
  components: {
    Goal
  },

  props: {
    showDeriveOption: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      rubricExample,
      singleExample
    };
  },

  methods: {
    selectSinglePoint() {
      this.$emit('select-single-point');
    },

    selectMultiPoint() {
      this.$emit('select-multi-point');
    },

    selectBaseOffExisting() {
      this.$emit('select-base-off-existing');
    }
  }
});
